export default "##### True Trade Area\n---\nSee where visitors of this location Live & Work. \n";